import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import React, { useContext, useEffect } from "react";
import { AuthPage } from "../views/AuthPage";
import UserController from "../controllers/UserController";
import User from "../models/User";

type Auth = {
    user: User | null;
    signUp: (email: string, displayName: string, password: string) => Promise<void>;
    logIn: (email: string, password: string) => Promise<void>;
    logOut: () => Promise<void>;
    reloadUser: () => void;
}

const authContext = React.createContext<Auth>({} as Auth);

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [user, setUser] = React.useState<User | null>(null);


    const signUp = async (email: string, displayName: string, password: string) => {
        return new Promise<void>((resolve, reject) => {
            createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                UserController.createUser(userCredential.user.uid, email, displayName).then((user) => {
                    setUser(user);
                    resolve();
                }).catch((error) => {
                    reject(error);
                });
            }).catch((error) => reject(error));
        });
    }
    
    const logIn = async (email: string, password: string) => {
        return new Promise<void>((resolve, reject) => {
            signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                UserController.getUser(userCredential.user.uid).then((user) => {
                    setUser(user);
                    resolve();
                }).catch((error) => {
                    reject(error);
                });
            }).catch((error) => reject(error));
        });
    }
    
    const logOut = async () => {
        auth.signOut()
        .then(() => { 
            setUser(null)
        })
    }

    const loadUser = (currUser: string) => {
        UserController.getUser(currUser).then((user) => {
            setUser(user);
        });
    }

    const reloadUser = () => {
        if(!user) return;
        loadUser(user.uid);
    }

    useEffect(() => {
        if(!auth.currentUser) return;
        loadUser(auth.currentUser.uid);
    }, [auth.currentUser]);

    if(!user) return (
        <authContext.Provider value={{logIn, logOut, signUp, reloadUser, user}}>
            <AuthPage />
        </authContext.Provider>
    );
    return (
        <authContext.Provider value={{logIn, logOut, signUp, reloadUser, user}}>
            {children}
        </authContext.Provider>
    );   
}

const useAuth = () => useContext(authContext);
export { useAuth, AuthProvider };